import React from 'react';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Global/Hero/Hero';
import TextContent from 'Component/TextContent/TextContent';
import MultiColumnFeature from 'Component/MultiColumnFeature/MultiColumnFeature';

import IconsData from 'IconsData/InstaCash.json';
import InvestInstaCash from 'TextContentData/InstaCash/InvestInstaCash.json';
import { WhatIsInstaCash } from 'TextContentData/InstaCash/WhatIsInstaCash.js';
import MultiColumnFeatureData from 'MultiColumnFeatureData/InstaCash.json';

const InstaCash = () => {
	return (
		<Layout>
			<SEO title="InstaCash" description="" />
			<Hero
				heading="InstaCash"
				iconsData={IconsData}
				breadcrumbs={[
					{
						text: 'Invest',
						link: '#',
					},
					{
						text: 'InstaCash',
						link: '#',
					},
				]}
				ctaFormText="Interested in investing in InstaCash?"
				customClass="bgInstaCash"
			/>
			<TextContent
				heading="How to invest in Instacash using Moneyfront"
				data={InvestInstaCash}
				customClass="investInstaCash"
				linkType="button"
				linkUrl="#"
				linkText="Get started with InstaCash"
			/>
			<TextContent
				heading="What is InstaCash?"
				data={WhatIsInstaCash}
				customClass="whatIsInstaCash"
				linkType="button"
				linkUrl="#"
				linkText="Get started with InstaCash"
				textBelowCta="Money lying idle in savings account? Earn higher returns from it."
				expand="expandMobile"
			/>
			<MultiColumnFeature
				heading="Benefits of InstaCash?"
				data={MultiColumnFeatureData}
				customClass="instaCashBenefits"
			/>
		</Layout>
	);
};

export default InstaCash;
